'use strict';

/**
 * @ngdoc function
 * @name thothApp.directives:inlineSuggestion
 * @description
 * # inlineSuggestion Directive
 * Completa el texto de un input con la primera opcion de una lista que empiece
 * igual a lo escrito. El sobrante se pinta en gris sobre el campo; el valor del
 * input no cambia hasta que el usuario acepta con Tab o flecha derecha.
 */

angular.module('thothApp.directives')
.directive('inlineSuggestion', function($timeout) {
  const ACCEPT_KEYS = { Tab: 9, ArrowRight: 39 };
  const TYPOGRAPHY = ['fontFamily', 'fontSize', 'fontWeight', 'letterSpacing'];

  const pressedKey = function(event) {
    return Object.keys(ACCEPT_KEYS).find(function(name) {
      return event.key === name || event.which === ACCEPT_KEYS[name] || event.keyCode === ACCEPT_KEYS[name];
    });
  };

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      const input = element[0];

      const hint = angular.element(
        '<span class="inline-suggestion-hint" data-cy="activity-description-hint" aria-hidden="true"></span>'
      );
      const wrapper = angular.element('<div class="inline-suggestion-wrapper"></div>');
      element.after(wrapper);
      wrapper.append(hint);

      let completion = '';

      const clear = function() {
        completion = '';
        hint.text('');
      };

      // Ancho real del texto con la tipografia del input. Sirve para colocar el
      // gris justo donde termina lo escrito, sin depender de espejear cajas.
      const measure = function(text) {
        const style = window.getComputedStyle(input);
        const probe = document.createElement('span');
        probe.style.cssText = 'position:absolute;visibility:hidden;white-space:pre';
        TYPOGRAPHY.forEach(function(property) {
          probe.style[property] = style[property];
          hint[0].style[property] = style[property];
        });
        probe.textContent = text;

        document.body.appendChild(probe);
        const width = probe.offsetWidth;
        document.body.removeChild(probe);

        return width;
      };

      // Vocabulario de las frases anteriores, de mas a menos usado. Se recalcula
      // solo cuando cambia la lista de origen.
      let vocabularySource = null;
      let vocabulary = [];

      const buildVocabulary = function(options) {
        if (options === vocabularySource) {
          return vocabulary;
        }
        vocabularySource = options;

        const uses = {};
        options.forEach(function(option) {
          if (typeof option !== 'string') {
            return;
          }
          option.split(/\s+/).forEach(function(word) {
            if (word.length > 2) {
              uses[word] = (uses[word] || 0) + 1;
            }
          });
        });

        vocabulary = Object.keys(uses).sort(function(a, b) {
          return uses[b] - uses[a] || a.localeCompare(b);
        });
        return vocabulary;
      };

      // La lista viene de fuera de la directiva, asi que no se asume su contenido.
      const startsWith = function(text, prefix) {
        return typeof text === 'string' &&
          text.length > prefix.length &&
          text.toLowerCase().indexOf(prefix.toLowerCase()) === 0;
      };

      const refresh = function() {
        const current = input.value || '';

        if (input.readOnly || current.trim() === '') {
          return clear();
        }

        const options = scope.$eval(attrs.inlineSuggestion) || [];

        // Primero la frase completa: si esta repitiendo una actividad conocida,
        // conviene ofrecersela entera.
        let match = options.find(function(option) {
          return startsWith(option, current);
        });

        // Si ya se desvio de toda frase registrada, se completa solo la palabra
        // que esta escribiendo.
        if (!match) {
          const cut = current.lastIndexOf(' ') + 1;
          const partial = current.slice(cut);

          if (partial.length >= 2) {
            const word = buildVocabulary(options).find(function(candidate) {
              return startsWith(candidate, partial);
            });
            if (word) {
              match = current + word.slice(partial.length);
            }
          }
        }

        if (!match) {
          return clear();
        }

        const style = window.getComputedStyle(input);
        const textStart = parseFloat(style.borderLeftWidth) + parseFloat(style.paddingLeft);
        const typedWidth = measure(current);

        // Con el texto desbordado el input se desplaza por dentro y el gris
        // dejaria de coincidir con lo escrito.
        if (textStart + measure(match) > input.clientWidth) {
          return clear();
        }

        completion = match;
        hint.text(match.slice(current.length));

        // md-dialog se abre con un transform de escala, asi que getBoundingClientRect
        // devuelve medidas escaladas. offsetLeft y offsetTop van en pixeles reales,
        // que es lo que espera style.left. El contenedor va despues del input, por
        // eso la posicion se calcula como diferencia entre ambos.
        hint[0].style.left = (input.offsetLeft - wrapper[0].offsetLeft + textStart + typedWidth) + 'px';
        hint[0].style.top = (input.offsetTop - wrapper[0].offsetTop) + 'px';
        hint[0].style.height = input.offsetHeight + 'px';
        hint[0].style.lineHeight = input.offsetHeight + 'px';
      };

      const accept = function() {
        ngModel.$setViewValue(completion);
        ngModel.$render();
        clear();
        $timeout(function() {
          input.setSelectionRange(input.value.length, input.value.length);
        });
      };

      element.on('input', function() {
        scope.$applyAsync(refresh);
      });

      element.on('keydown', function(event) {
        const key = completion && pressedKey(event);
        if (!key) {
          return;
        }
        // La flecha derecha solo completa si el cursor ya esta al final.
        if (key === 'ArrowRight' && input.selectionStart !== input.value.length) {
          return;
        }
        event.preventDefault();
        scope.$apply(accept);
      });

      element.on('blur', function() {
        scope.$applyAsync(clear);
      });

      scope.$on('$destroy', function() {
        element.off('input keydown blur');
        // El contenedor es hermano del input, asi que no se va solo cuando el
        // input desaparece.
        wrapper.remove();
      });
    }
  };
});
